var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 19,
    viewBox: "0 0 9 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83936 9.91113C6.83936 9.99316 6.8042 10.0693 6.73389 10.1396L2.05811 14.8154C1.98779 14.8857 1.91162 14.9209 1.82959 14.9209C1.73584 14.9209 1.65967 14.8857 1.60107 14.8154L1.09131 14.3232C1.021 14.2529 0.98584 14.1768 0.98584 14.0947C0.98584 14.001 1.021 13.9248 1.09131 13.8662L5.04639 9.91113L1.09131 5.95605C1.021 5.89746 0.98584 5.82129 0.98584 5.72754C0.98584 5.64551 1.021 5.56934 1.09131 5.49902L1.60107 5.00684C1.65967 4.93652 1.73584 4.90137 1.82959 4.90137C1.91162 4.90137 1.98779 4.93652 2.05811 5.00684L6.73389 9.68262C6.8042 9.75293 6.83936 9.8291 6.83936 9.91113Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.7,
    height: 18,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.909912 18.9111)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.3ec942bfd33eb246b707ce347cf1b298.svg";
export { ForwardRef as ReactComponent };